// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/img/background.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/fonts/mini-icons.woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
	margin: 0;
	margin-left: 0;
	color: #ddd;
	font-family: "Raleway", "HelveticaNeue", "Helvetica Neue", Helvetica, Arial, sans-serif;
	position: relative;
	min-height: calc(100vh);
}

#main-container {
	background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
	background-color: rgb(32, 32, 32);
	background-position: calc(100vw - 1200px) 40px;
	background-repeat: no-repeat;
	background-attachment: local;
}

@media (max-width: 1600px) {
	body {
		overflow-x: hidden;
	}
}

@media (max-width: 1000px) {
	#main-container {
		background-position: 50% 4em;
	}
}

@media (max-width: 650px) {
	#main-container {
		background-position: 50% 10em;
	}
}

@media (max-width: 500px) {
	#main-container {
		background-position: 50% 12em;
	}
}

.link,
a:not(.reset-style),
a:visited:not(.reset-style) {
	color: #518ae6;
	text-decoration: none;
	cursor: pointer;
}

.link:hover,
a:not(.reset-style):hover {
	color: #72a7ff;
}

a.reset-style,
a.reset-style:visited {
	color: #ddd;
	text-decoration: none;
}

pre {
	background-color: #333;
	padding: 0.5em;
	tab-size: 4;
}

label {
	margin: 0.25em;
}

.capitalized {
	text-transform: capitalize;
}

.inline {
	display: inline-block;
}

.clickable {
	cursor: pointer;
	transition:
		opacity 0.25s,
		color 0.25s;
}

.clickable:hover {
	color: #fff;
}

.clickable:focus {
	outline: none;
}

.clickable:focus-visible {
	outline: -webkit-focus-ring-color auto 5px;
}

.faded {
	opacity: 0.5;
}

.crossed {
	position: relative;
}

.crossed:after {
	position: absolute;
	content: "";
	background-color: #ddd;
	top: 40%;
	left: calc(-14px + 50%);
	height: 2.8px;
	width: 28px;
	transform: rotate(36deg);
	box-shadow: 0 2px #333;
	border-radius: 0.5px;
}

.draggable {
	cursor: grab;
}

.green {
	color: green;
}

.yellow {
	color: yellow;
}

.brightred {
	color: red;
}

.red {
	color: DarkRed;
}

.blue {
	color: #3666b3;
}

.gold {
	color: gold;
}

.subtle-gold {
	text-shadow: 0 0 1px gold;
}

.redbg {
	background-color: DarkRed;
	border-radius: 0.2em;
}

.no-event {
	pointer-events: none;
}

.disabled {
	pointer-events: none;
	opacity: 0.3;
	background: repeating-linear-gradient(45deg, #282828, #282828 10px, #383838 10px, #383838 20px);
}

.disabled-simple {
	pointer-events: none;
	opacity: 0.3;
}

.opaque-disabled {
	pointer-events: none;
	filter: brightness(0.4);
}

.greyed-out {
	opacity: 0.3;
}

.small-number-input {
	width: 3em;
}

.generic-container {
	position: relative;
}

.teama,
.bracket-player.teama,
.player-list > .teama,
ul.player-table > li.teama {
	background: #21402e !important;
}

.teamb,
.bracket-player.teamb,
.player-list > .teamb,
ul.player-table > li.teamb {
	background: #222440 !important;
}

.message {
	background-color: #282828;
	border-radius: 10px;
	box-shadow: inset 0 0 8px #383838;
	text-align: center;
	padding: 1em;
}

.input-delete-icon {
	position: relative;
}

.input-delete-icon span {
	position: absolute;
	display: block;
	top: 50%;
	right: 0.5em;
	width: 1em;
	height: 1em;
	transform: translateY(-50%);
	cursor: pointer;
	opacity: 70%;
}

.input-delete-icon span:hover {
	opacity: 100%;
}

.input-delete-icon input {
	padding-right: 16px;
	box-sizing: border-box;
}

.fade-enter-from,
.fade-leave-to {
	opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.1s ease-in-out;
}

@font-face {
	font-family: "Mini Font Awesome 5 Free";
	font-style: normal;
	font-weight: 900;
	font-display: block;
	src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2");
}
`, "",{"version":3,"sources":["webpack://./client/src/css/style.css"],"names":[],"mappings":"AAAA;CACC,SAAS;CACT,cAAc;CACd,WAAW;CACX,uFAAuF;CACvF,kBAAkB;CAClB,uBAAuB;AACxB;;AAEA;CACC,mDAAgD;CAChD,iCAAiC;CACjC,8CAA8C;CAC9C,4BAA4B;CAC5B,4BAA4B;AAC7B;;AAEA;CACC;EACC,kBAAkB;CACnB;AACD;;AAEA;CACC;EACC,4BAA4B;CAC7B;AACD;;AAEA;CACC;EACC,6BAA6B;CAC9B;AACD;;AAEA;CACC;EACC,6BAA6B;CAC9B;AACD;;AAEA;;;CAGC,cAAc;CACd,qBAAqB;CACrB,eAAe;AAChB;;AAEA;;CAEC,cAAc;AACf;;AAEA;;CAEC,WAAW;CACX,qBAAqB;AACtB;;AAEA;CACC,sBAAsB;CACtB,cAAc;CACd,WAAW;AACZ;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,eAAe;CACf;;aAEY;AACb;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,0CAA0C;AAC3C;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,sBAAsB;CACtB,QAAQ;CACR,uBAAuB;CACvB,aAAa;CACb,WAAW;CACX,wBAAwB;CACxB,sBAAsB;CACtB,oBAAoB;AACrB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;CACzB,oBAAoB;AACrB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,oBAAoB;CACpB,YAAY;CACZ,+FAA+F;AAChG;;AAEA;CACC,oBAAoB;CACpB,YAAY;AACb;;AAEA;CACC,oBAAoB;CACpB,uBAAuB;AACxB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,kBAAkB;AACnB;;AAEA;;;;CAIC,8BAA8B;AAC/B;;AAEA;;;;CAIC,8BAA8B;AAC/B;;AAEA;CACC,yBAAyB;CACzB,mBAAmB;CACnB,iCAAiC;CACjC,kBAAkB;CAClB,YAAY;AACb;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,QAAQ;CACR,YAAY;CACZ,UAAU;CACV,WAAW;CACX,2BAA2B;CAC3B,eAAe;CACf,YAAY;AACb;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,mBAAmB;CACnB,sBAAsB;AACvB;;AAEA;;CAEC,UAAU;AACX;;AAEA;;CAEC,oCAAoC;AACrC;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,gBAAgB;CAChB,mBAAmB;CACnB,4DAA4D;AAC7D","sourcesContent":["body {\n\tmargin: 0;\n\tmargin-left: 0;\n\tcolor: #ddd;\n\tfont-family: \"Raleway\", \"HelveticaNeue\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n\tposition: relative;\n\tmin-height: calc(100vh);\n}\n\n#main-container {\n\tbackground: url(\"../assets/img/background.webp\");\n\tbackground-color: rgb(32, 32, 32);\n\tbackground-position: calc(100vw - 1200px) 40px;\n\tbackground-repeat: no-repeat;\n\tbackground-attachment: local;\n}\n\n@media (max-width: 1600px) {\n\tbody {\n\t\toverflow-x: hidden;\n\t}\n}\n\n@media (max-width: 1000px) {\n\t#main-container {\n\t\tbackground-position: 50% 4em;\n\t}\n}\n\n@media (max-width: 650px) {\n\t#main-container {\n\t\tbackground-position: 50% 10em;\n\t}\n}\n\n@media (max-width: 500px) {\n\t#main-container {\n\t\tbackground-position: 50% 12em;\n\t}\n}\n\n.link,\na:not(.reset-style),\na:visited:not(.reset-style) {\n\tcolor: #518ae6;\n\ttext-decoration: none;\n\tcursor: pointer;\n}\n\n.link:hover,\na:not(.reset-style):hover {\n\tcolor: #72a7ff;\n}\n\na.reset-style,\na.reset-style:visited {\n\tcolor: #ddd;\n\ttext-decoration: none;\n}\n\npre {\n\tbackground-color: #333;\n\tpadding: 0.5em;\n\ttab-size: 4;\n}\n\nlabel {\n\tmargin: 0.25em;\n}\n\n.capitalized {\n\ttext-transform: capitalize;\n}\n\n.inline {\n\tdisplay: inline-block;\n}\n\n.clickable {\n\tcursor: pointer;\n\ttransition:\n\t\topacity 0.25s,\n\t\tcolor 0.25s;\n}\n\n.clickable:hover {\n\tcolor: #fff;\n}\n\n.clickable:focus {\n\toutline: none;\n}\n\n.clickable:focus-visible {\n\toutline: -webkit-focus-ring-color auto 5px;\n}\n\n.faded {\n\topacity: 0.5;\n}\n\n.crossed {\n\tposition: relative;\n}\n\n.crossed:after {\n\tposition: absolute;\n\tcontent: \"\";\n\tbackground-color: #ddd;\n\ttop: 40%;\n\tleft: calc(-14px + 50%);\n\theight: 2.8px;\n\twidth: 28px;\n\ttransform: rotate(36deg);\n\tbox-shadow: 0 2px #333;\n\tborder-radius: 0.5px;\n}\n\n.draggable {\n\tcursor: grab;\n}\n\n.green {\n\tcolor: green;\n}\n\n.yellow {\n\tcolor: yellow;\n}\n\n.brightred {\n\tcolor: red;\n}\n\n.red {\n\tcolor: DarkRed;\n}\n\n.blue {\n\tcolor: #3666b3;\n}\n\n.gold {\n\tcolor: gold;\n}\n\n.subtle-gold {\n\ttext-shadow: 0 0 1px gold;\n}\n\n.redbg {\n\tbackground-color: DarkRed;\n\tborder-radius: 0.2em;\n}\n\n.no-event {\n\tpointer-events: none;\n}\n\n.disabled {\n\tpointer-events: none;\n\topacity: 0.3;\n\tbackground: repeating-linear-gradient(45deg, #282828, #282828 10px, #383838 10px, #383838 20px);\n}\n\n.disabled-simple {\n\tpointer-events: none;\n\topacity: 0.3;\n}\n\n.opaque-disabled {\n\tpointer-events: none;\n\tfilter: brightness(0.4);\n}\n\n.greyed-out {\n\topacity: 0.3;\n}\n\n.small-number-input {\n\twidth: 3em;\n}\n\n.generic-container {\n\tposition: relative;\n}\n\n.teama,\n.bracket-player.teama,\n.player-list > .teama,\nul.player-table > li.teama {\n\tbackground: #21402e !important;\n}\n\n.teamb,\n.bracket-player.teamb,\n.player-list > .teamb,\nul.player-table > li.teamb {\n\tbackground: #222440 !important;\n}\n\n.message {\n\tbackground-color: #282828;\n\tborder-radius: 10px;\n\tbox-shadow: inset 0 0 8px #383838;\n\ttext-align: center;\n\tpadding: 1em;\n}\n\n.input-delete-icon {\n\tposition: relative;\n}\n\n.input-delete-icon span {\n\tposition: absolute;\n\tdisplay: block;\n\ttop: 50%;\n\tright: 0.5em;\n\twidth: 1em;\n\theight: 1em;\n\ttransform: translateY(-50%);\n\tcursor: pointer;\n\topacity: 70%;\n}\n\n.input-delete-icon span:hover {\n\topacity: 100%;\n}\n\n.input-delete-icon input {\n\tpadding-right: 16px;\n\tbox-sizing: border-box;\n}\n\n.fade-enter-from,\n.fade-leave-to {\n\topacity: 0;\n}\n\n.fade-enter-active,\n.fade-leave-active {\n\ttransition: opacity 0.1s ease-in-out;\n}\n\n@font-face {\n\tfont-family: \"Mini Font Awesome 5 Free\";\n\tfont-style: normal;\n\tfont-weight: 900;\n\tfont-display: block;\n\tsrc: url(\"../assets/fonts/mini-icons.woff2\") format(\"woff2\");\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
